import { contentTypeForFile } from './fileUpload';
import { agentFetch } from './agentApi';

export const PROPERTY_PHOTO_ACCEPT = 'image/jpeg,image/png,image/heic,image/heif,.jpg,.jpeg,.png,.heic,.heif';

const PHOTO_TYPES = new Set(['image/jpeg', 'image/png', 'image/heic', 'image/heif']);

export function propertyPhotoError(file) {
  if (!file) return '';
  const type = contentTypeForFile(file);
  if (!PHOTO_TYPES.has(type)) return 'Use a JPG, PNG, or HEIC photo.';
  if (file.size > 10 * 1024 * 1024) return 'Photo must be 10 MB or less.';
  return '';
}

export async function uploadAgentPropertyPhoto(clientId, file) {
  const problem = propertyPhotoError(file);
  if (problem) throw new Error(problem);
  const contentType = contentTypeForFile(file);
  const { ok, body } = await agentFetch('/api/property-photo', {
    method: 'POST',
    body: JSON.stringify({
      clientId,
      fileName: file.name || 'photo.jpg',
    }),
  });
  if (!ok || !body || !body.signedUrl) {
    throw new Error((body && body.error) || 'Could not start the photo upload.');
  }
  const response = await fetch(body.signedUrl, {
    method: 'PUT',
    headers: { 'Content-Type': body.contentType || contentType },
    body: file,
  });
  if (!response.ok) throw new Error('The photo did not upload.');
  return body.publicUrl;
}
